import Router from "vue-router"
import { Login, LoginEmail, SignUp, ResetPassword } from "@/components/auth"
import Offer from "@/components/offer"
import MealDetail from "@/components/meal-detail"
import Meals from "@/components/meals"
import Screens from "@/components/screens"
import Screen from "@/components/screen"
import ProjectSettings from "@/components/settings/project-settings"
import AccountSettings from "@/components/settings/account-settings"
import ProjectManager from "@/components/project-manager"
import OfferManager from "@/components/settings/offer-management"
import Project from "@/components/project"
import DeviceHome from "@/components/device/device-home"
import { state, actions } from "@/store"

const router = new Router({
  routes: [
    {
      path: "/projects/:projectId",
      props: true,
      component: Project,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "offers/:offerId",
          props: true,
          component: Offer
        },
        {
          path: "offers-management/:selectedOfferId",
          props: true,
          component: OfferManager
        },
        {
          path: "offers-management",
          component: OfferManager
        },
        {
          path: "meals",
          props: true,
          component: Meals
        },
        {
          path: "meals/:mealId",
          props: true,
          component: MealDetail
        },
        {
          path: "screens",
          props: true,
          component: Screens
        },
        {
          path: "settings",
          component: ProjectSettings
        },
        {
          path: "screen/:idx",
          props: true,
          component: Screen,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "",
          redirect: "meals"
        }
      ]
    },
    {
      path: "/device",
      component: DeviceHome
    },
    {
      path: "/manager",
      component: ProjectManager,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/account-settings",
      component: AccountSettings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/login",
      component: Login
    },
    {
      path: "/login-email/:initialEmail?",
      props: true,
      component: LoginEmail
    },
    {
      path: "/sign-up",
      component: SignUp
    },
    {
      path: "/reset-password",
      component: ResetPassword
    },
    {
      path: "*",
      redirect: "manager"
    }
  ]
})

router.beforeEach((to, from, next) => {
  actions.clearErrors()
  const requiresAuth = to.matched
    .map(record => record.meta.requiresAuth)
    .filter(reqAuth => typeof reqAuth === "boolean")
    .reverse()[0]
  const isGranted = () => {
    return !requiresAuth || state.isUserLogged
  }
  if (isGranted()) {
    next()
    return
  }
  const failWithLogout = (message, error) => {
    actions.logout()
    next("/login")
    if (message) {
      actions.addError(message)(error)
    }
  }
  actions.initAuthListener(
    () => {
      next()
    },
    () => failWithLogout(),
    err => failWithLogout("Auth error occured", err)
  )
})

export default router
